import { render, staticRenderFns } from "./SliderPrice.vue?vue&type=template&id=59883adb&scoped=true&"
import script from "./SliderPrice.vue?vue&type=script&lang=js&"
export * from "./SliderPrice.vue?vue&type=script&lang=js&"
import style0 from "./SliderPrice.vue?vue&type=style&index=0&id=59883adb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59883adb",
  null
  
)

export default component.exports